/* eslint-disable react/prop-types */
import React from 'react'

const Separator = (props) => {
  return (

    <div>
      <div style={{ height: '4px' }} />
    </div>
  )
}

export const SeparatorHeader = (props) => {
  return (
    <div style={{ height: '80px' }}>
    </div>
  )
}

export const SeparatorSmall = (props) => {
  return (
    <div style={{ height: '10px' }}>
    </div>
  )
}

export const CustomSeparator = (props) => {
  return (
    <div style={{ height: props.Size }}>
    </div>
  )
}

export default Separator
